<template>
  <div class="enterprise-identity-container d-flex flex-column justify-content-start align-items-center">
    <IdentityVerificationHeader v-if="!showManualVerification" />
    <div class="identity-verification-container d-flex flex-column justify-content-start align-items-start"
      v-if="!showManualVerification">
      <IdentityVerificationStepper :currentStep="currentStep" />
      <BeginIdentityVerification v-if="currentStep === 0" @nextStep="handleEmailValidation"
        :userDataUsageConsent="userDataUsageConsent" :isRestrictedRegion="isRestrictedRegion"
        :isNewHire="isNewHire" :isRetryExceeded="isRetryExceeded" @showManualVerification="showManualVerificationPage"
        :verifiedIn24hrs="verifiedIn24hrs" :isContingent="isContingent" />
      <DownloadNametagApp v-if="currentStep === 1" @nextStep="handleNextStep" />
      <GenerateQRCode v-if="currentStep === 2" :link="qrCodeLink" :errorMessage="errorMessage"
        @nextStep="handleIdentityValidation" @showManualVerification="showManualVerificationPage" :email="userEmail" :isContingent="isContingent" />
      <CompleteIdentityVerification v-if="currentStep === 3 || currentStep === 4"
        :emailValidationStatus="emailValidationStatus" :identityValidationStatus="identityValidationStatus"
        :userEmail="userEmail" @nextStep="handleNextStep" @showManualVerification="showManualVerificationPage"
        :isRetryExceeded="isRetryExceeded" :isContingent="isContingent" />
    </div>
    <ManualVerification v-if="showManualVerification" />
    <IdentityVerificationFooter v-if="!showManualVerification" :currentStep="currentStep"
      :serviceDeskNumber="serviceDeskNumber" :serviceDeskEmail="serviceDeskEmail" :isContingent="isContingent" />
  </div>
</template>

<script>
import IdentityVerificationHeader from "@/components/IdentityVerificationHeader.vue";
import IdentityVerificationStepper from "@/components/IdentityVerificationStepper.vue";
import BeginIdentityVerification from "@/components/BeginIdentityVerification.vue";
import DownloadNametagApp from "@/components/DownloadNametagApp.vue";
import GenerateQRCode from "@/components/GenerateQRCode.vue";
import CompleteIdentityVerification from "./CompleteIdentityVerification.vue";
import ManualVerification from "@/components/ManualVerification.vue";
import IdentityVerificationFooter from "@/components/IdentityVerificationFooter.vue";
import CONSTANTS from "@/constants";

export default {
  name: "EnterpriseIdentityVerification",
  components: {
    IdentityVerificationHeader,
    IdentityVerificationStepper,
    BeginIdentityVerification,
    DownloadNametagApp,
    GenerateQRCode,
    CompleteIdentityVerification,
    ManualVerification,
    IdentityVerificationFooter
  },
  data() {
    return {
      currentStep: 0,
      showManualVerification: false,
      qrCodeLink: '',
      message: '',
      errorMessage: '',
      userEmail: '',
      emailValidationStatus: '',
      identityValidationStatus: '',
      isRestrictedRegion: false,
      isNewHire: false,
      isContingent: false,
      verifiedIn24hrs: false,
      isRetryExceeded: false,
      userDataUsageConsent: CONSTANTS.USER_DATA_USAGE_CONSENT,
      serviceDeskNumber: CONSTANTS.SERVICE_DESK_NUMBER,
      serviceDeskEmail: CONSTANTS.SERVICE_DESK_EMAIL
    };
  },
  methods: {
    handleEmailValidation(response, userEmail) {
      this.message = JSON.parse(response.body)
      if (response.statusCode == 200) {
        if (this.message.message.includes("24 hrs")) {
          this.verifiedIn24hrs = true;
        }
        if(this.message.message.includes("Max retry")) {
          this.isRetryExceeded = true;
        }
        this.qrCodeLink = this.message.message
        this.isRestrictedRegion = response.is_restricted_region || false;
        this.isNewHire = response.is_new_hire || false;
        this.isContingent = response.is_contingent || false;
      } else { this.errorMessage = this.message.message; }
      this.userEmail = userEmail;
      this.currentStep = 1;
    },
    handleIdentityValidation(response, nextStep) {
      this.currentStep = nextStep;
      this.emailValidationStatus = response.user_email_validation_status;
      this.identityValidationStatus = response.identity_verification_status
      this.isRetryExceeded = response.retry == 4;
    },
    handleNextStep(nextStep) {
      this.currentStep = nextStep;
    },
    showManualVerificationPage() {
      this.showManualVerification = true;
    }
  }
};
</script>

<style>
.enterprise-identity-container {
  min-height: 90vh;
  height: auto;
  /* padding: 20px; */
}

.identity-verification-container {
  width: 100%;
  height: auto;
  padding: 20px;
  max-width: 1200px;
}

@media (max-width: 700px) {
  .identity-verification-container {
    flex-direction: row;
    padding: 20px;
  }
}
</style>
